import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-footer"
}
const _hoisted_2 = { class: "table-footer-text" }
const _hoisted_3 = { class: "table-footer-btns" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["disabled"]

import { ChevronLeft, ChevronRight } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePagination',
  props: {
    currentPage: {},
    totalPages: {},
    totalItems: {},
    showingCount: {},
    itemLabel: { default: 'items' }
  },
  emits: ["page-change"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_ctx.totalPages > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _cache[2] || (_cache[2] = _createTextVNode(" Showing ")),
          _createElementVNode("strong", null, _toDisplayString(_ctx.showingCount), 1),
          _cache[3] || (_cache[3] = _createTextVNode(" of ")),
          _createElementVNode("strong", null, _toDisplayString(_ctx.totalItems), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.itemLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "pagination-btn",
            disabled: _ctx.currentPage <= 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('page-change', _ctx.currentPage - 1)))
          }, [
            _createVNode(_unref(ChevronLeft), { class: "h-4 w-4" })
          ], 8, _hoisted_4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
            return (_openBlock(), _createElementBlock("button", {
              key: page,
              class: _normalizeClass(["pagination-btn", { 'pagination-btn--active': page === _ctx.currentPage }]),
              onClick: ($event: any) => (_ctx.$emit('page-change', page))
            }, _toDisplayString(page), 11, _hoisted_5))
          }), 128)),
          _createElementVNode("button", {
            class: "pagination-btn",
            disabled: _ctx.currentPage >= _ctx.totalPages,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('page-change', _ctx.currentPage + 1)))
          }, [
            _createVNode(_unref(ChevronRight), { class: "h-4 w-4" })
          ], 8, _hoisted_6)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})